<template>
  <index-loader></index-loader>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <dashboard-header :title="title" @filter-toggle="handleFilterToggle" />
          <div class="contact-head" v-if="opp_Id">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <ul class="contact-breadcrumb">
                  <li>
                    <router-link
                      :to="{ path: '/crm/organisation-details', query: { ter_Id: territory_id, org_Id: org_Id, opp_Id: opp_Id, for: 'opportunities', add: 'quote' } }">
                      <i class="ti ti-arrow-narrow-left"></i>
                      Organisation
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      path: `/crm/meter-opportunities-edit/${opp_Id}`
                    }"> <i class="ti ti-arrow-narrow-left"></i> Meter
                      Opportunity</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row position-relative m-0">
            <div class="user-accordion-item">
              <a href="javascript:;" class="accordion-wrap" data-bs-toggle="collapse"
                data-bs-target="#basicDetails"><span><i class="ti ti-details"></i></span>Gas / Electricity
                Details</a>
              <div class="accordion-collapse collapse show" id="basicDetails" data-bs-parent="#list-accord">
                <div class="content-collapse m-0 p-0">
                  <div class="col-md-12">
                    <div class="contact-tab-wrap mb-2 px-2">
                      <ul class="contact-nav nav mb-2 justify-content-between">
                        <div class="d-flex mb-3 mb-sm-0">
                          <li class="m-0">
                            <a href="javascript:;" data-bs-toggle="tab" data-bs-target="#gas"
                              :class="{ active: activeTab === 'gas' }" @click="setActiveTab('gas')">Gas</a>
                          </li>
                          <!-- @click="activeTab = 'gas'" -->
                          <li class="">
                            <a href="javascript:;" data-bs-toggle="tab" data-bs-target="#electricity"
                              :class="{ active: activeTab === 'electricity' }"
                              @click="setActiveTab('electricity')">Electricity</a>
                          </li>
                        </div>
                        <!-- @click="activeTab = 'electricity'" -->
                        <!-- <li class="col-md-8 me-0">

                        </li> -->
                        <button type="button" class="w-auto btn btn-primary py-2" @click="addCustomQuote">
                          Add a Custom Quote
                        </button>
                      </ul>
                      <button type="button" class="btn btn-primary py-2 m-2" @click="compare">
                        Compare
                      </button>
                    </div>

                    <!-- Tab Content -->
                    <div class="contact-tab-view mb-0 p-2">
                      <div class="tab-content pt-0">
                        <!-- gas -->
                        <div class="tab-pane" :class="{ 'active show': activeTab === 'gas' }" id="gas">
                          <quoting-gas :queryFor="queryFor" @submit-form="submitFormData" :isNotValid="isNotValid"
                            :isEmailValid="isEmailValid" :validEmail="validEmail" :gasOppId="gasOppId"></quoting-gas>
                        </div>

                        <!-- electricity -->
                        <div class="tab-pane" :class="{ 'active show': activeTab === 'electricity' }" id="electricity">
                          <quoting-electricity ref="quotingElectricityRef" @submit-elctric-form="submitFormData" :isElecNotValid="isElecNotValid"
                            :isEmailValid="isEmailValidElec" :validEmail="validEmail"
                            :elecOppId="elecOppId"></quoting-electricity>
                        </div>
                      </div>
                    </div>
                    <!-- /Tab Content -->
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 p-0">
              <div class="filter-panel" :class="{ open: isFilterOpen }">
                <button type="btn" class="btn btn-primary filter_btn p-1" @click="handleFilterToggle"><i
                    class="ti ti-arrow-bar-to-right"></i></button>
                <refine-filter :uniqueSuppliers="filteredSuppliers" @update-selected-suppliers="UpdateSuppliers"
                  @update:isYear="updateIsYear" @updateyears="updateSelectedYears" @min-months="handleMinMonths"
                  @max-months="handleMaxMonths" @update-suppliers-list="updateSupplierList" @update-renewable-filter="showRenewableOnly = $event"></refine-filter>
              </div>
            </div>
            <div class="col-md-12 p-0 position-relative">
              <!-- v-if="activeTab === 'gas'" -->
              <quoting-data v-if="filteredSuppliersRateList?.length > 0 || isCompareGas || isCompareElec"
                :suppliersRateList="filteredSuppliersRateList" :isElectric="isElectric"
                :selectedSuppliers="selectedSuppliers" :isYear="isYear" :selectedYears="selectedYears"
                :minMonths="minMonths" :maxMonths="maxMonths"
                :formData="activeTab === 'gas' ? gasformData : elecformData" @emailValidation="emailValidation"
                @changeUplift="changeUplift" @remove-row="deleteRow"></quoting-data>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <div ref="custom_quote" class="modal fade" id="custom_quote" tabindex="-1" role="dialog"
    aria-labelledby="custom_quote_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class="">Add New Custom Quote</h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close" @click="cancel_change">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <Form @submit="confirm_change">
          <div class="modal-body confirm">
            <div class="row">
              <div class="col-md-12" ref="dropdownContainer">
                <div class="form-wrap">
                  <label class="col-form-label">Supplier <span class="text-danger">*</span></label>
                  <Field name="Supplier" type="text" class="form-control" placeholder="Search supplier name"
                    v-model="form.Supplier" @keydown.enter="searchSupplier" @input="onInput" @focus="showDropdown" />
                  <ul v-if="filteredSupp.length" class="dropdown-menu supplier-data shadow show pe-0">
                    <li class="dropdown-listing">
                      <ul>
                        <li v-for="res in filteredSupp" :key="res.name" @click="selectSupplier(res)"
                          class="dropdown-item" style="cursor: pointer">
                          {{ res.name }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!-- <ErrorMessage name="Supplier" class="text-danger" /> -->
                  <span v-if="isValid.supplier" class="text-danger"> Supplier is required</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-wrap">
                  <label class="col-form-label">Product</label>
                  <Field name="product" as="input" type="text" class="form-control" v-model="form.PlanType" />
                </div>
              </div>
              <!-- <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Term</label>
                  <Field name="term" as="input" type="text" class="form-control" v-model="form.Term"
                    @keypress="$utils.allowOnlyNumbers" />
                </div>
              </div> -->

              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Term <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <Field name="term" as="input" type="text" class="form-control" v-model="form.Term"
                      @keypress="$utils.allowOnlyInteger" />
                    <span class="input-group-text">year</span>
                  </div>
                  <span v-if="isValid.term && termError" class="text-danger"> {{ termError }}</span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Day Rate (pence/kWh)</label>
                  <div class="input-group">
                    <Field name="DayUnitrate" as="input" type="text" class="form-control" v-model="form.DayUnitrate"
                      @keypress="$utils.allowOnlyNumbers" />
                    <span class="input-group-text">Base rate</span>
                  </div>
                </div>
              </div>
              <div v-if="activeTab === 'electricity'" class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Night Rate (pence/kWh)</label>
                  <Field name="NightUnitrate" as="input" type="text" class="form-control" v-model="form.NightUnitrate"
                    @keypress="$utils.allowOnlyNumbers" />
                </div>
              </div>
              <div v-if="activeTab === 'electricity'" class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Eve/Wknd Rate (pence/kWh)</label>
                  <Field name="WendUnitrate" as="input" type="text" class="form-control" v-model="form.WendUnitrate"
                    @keypress="$utils.allowOnlyNumbers" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Standing Charge (pence/day)</label>
                  <div class="input-group">
                    <Field name="standing_charge" as="input" type="text" class="form-control"
                      v-model="form.StandingCharge" @keypress="$utils.allowOnlyNumbers" />
                    <span class="input-group-text">Base s/c</span>
                  </div>
                </div>
              </div>
              <div v-if="activeTab === 'electricity'" class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">KVA Charge</label>
                  <div class="input-group">
                    <Field name="kva" as="input" type="text" class="form-control" v-model="form.kva"
                      @keypress="$utils.allowOnlyNumbers" />
                    <select v-model="kvaselection" class="form-select">
                      <option selected value="perday">per day</option>
                      <option value="permonth">per month</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Additional Charge (£)</label>
                  <Field name="additional_charge" as="input" type="text" class="form-control"
                    v-model="form.AdditionalCharge" @keypress="$utils.allowOnlyNumbers" />
                  <span class="">(added to annual cost)</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-wrap">
                  <label class="col-form-label">Extra Info</label>
                  <Field name="extra_info" as="input" type="text" class="form-control" v-model="form.ExtraInfo" />
                </div>
              </div>
              <div class="col-md-6" v-if="!isUplift">
                <div class="form-wrap">
                  <label class="col-form-label">U4B Uplift
                  </label>
                  <Field as="input" name="u4b_uplift" type="text" class="form-control" v-model="form.Uplift
                    " @keypress="$utils.allowOnlyNumbers" />
                  <ErrorMessage name="u4b_uplift" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex align-items-center gap-1 status-toggle">
                  <input type="checkbox" id="uplift" class="check" v-model="isUplift" @change="handleUplift" />
                  <label for="uplift" class="checktoggle"> </label>
                  <label class="form-check-label mb-0" for="uplift">Uplift include in rate</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-primary confirm-btn me-2">
                  Add Custom Quote
                </button>
                <button type="button" class="btn btn-outline-secondary cancel-btn" @click="cancel_change">
                  close
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>

  </div>

</template>

<script>
import {
  ref
} from "vue";
import {
  useRouter,
  useRoute
} from "vue-router";
import {
  onMounted,
  computed,
  nextTick
} from "vue";
import {
  useStore,
  mapGetters
} from "vuex";
import {
  message
} from "ant-design-vue";
import { Modal } from "bootstrap";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      title: "Quoting",
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const gasformData = ref(null);
    const elecformData = ref(null);
    const formData = ref(null);
    const isFilterOpen = ref(false);
    const suppliersRateList = ref([]);
    const elecSuppliersRateList = ref([]);
    const isElectric = ref(false);
    const activeTab = ref("gas");
    const uniqueSuppliers = ref([]);
    const uniqueElectricSuppliers = ref([]);
    const isYear = ref(false);
    const selectedYears = ref([]);
    const selectedSuppliers = ref([]);
    const isNotValid = ref(false);
    const isElecNotValid = ref(false);
    const minMonths = ref(12);
    const maxMonths = ref(60);
    const elecOppId = ref(null);
    const gasOppId = ref(null);
    const validEmail = ref({});
    // const queryFor = ref('');
    const territory_id = ref(route.query.ter_Id || null);
    const opp_Id = ref(route.query.opp_Id || null)
    const org_Id = ref(route.query.org_Id || null)
    // Methods to handle emitted events
    const handleMinMonths = (newMin) => {
      minMonths.value = newMin;
    };

    const editableUplift = ref([])
    const editableElecUplift = ref([])

    const customQuoteList = ref([])
    const elecCustomQuoteList = ref([])
    const filteredSupp = ref([])
    const dropdownContainer = ref(null);
    const supplierOptions = computed(() => store.getters["price/getSuppliers"]);
    const pozitiveElecUpliftsRange =  computed(() =>  store.getters['price/getPozitiveUplifts']);
    const isUplift = ref(false)

    const kvaselection = ref('perday')

    const schema = Yup.object().shape({
      Supplier: Yup.string().required("Supplier is required")
    })

    const isValid = ref({
      supplier: false,
      term: false
    })
    const gasPriceList = ref([])
    const elecPriceList = ref([])

    const isCompareGas = ref(false)
    const isCompareElec = ref(false)
    const quotingElectricityRef = ref(null)

    const queryFor = ref('');
    const termError = ref('')

    const isEmailValid = ref(false)
    const isEmailValidElec = ref(false)

    const form = ref({
      Supplier: '',
      PlanType: '',
      Term: null,
      DayUnitrate: '',
      StandingCharge: '',
      AdditionalCharge: '',
      ExtraInfo: '',
      Uplift: '',
      AnnualPrice: '',
      NightUnitrate: '',
      WendUnitrate: '',
      kva: '',
      isCustom: true
    })

    const handleMaxMonths = (newMax) => {
      maxMonths.value = newMax;
    };

    const handleFilterToggle = () => {
      isFilterOpen.value = !isFilterOpen.value;
    };
    const updateSelectedYears = (years) => {
      selectedYears.value = years;
    };
    const updateIsYear = (newValue) => {
      isYear.value = newValue;
    };
    const emailValidation = (data) => {
      if (data.errors) {
        validEmail.value = data.errors;
      } else {
        if (activeTab.value === "gas") {
          isNotValid.value = data;
          isEmailValid.value = data
          validEmail.value = {}
        } else {
          isElecNotValid.value = data;
          validEmail.value = {}
          isEmailValidElec.value = data
        }
      }
    }
    const setActiveTab = (tab) => {
      activeTab.value = tab
      // isEmailValid.value = false
    }
    const submitFormData = (data) => {
      if (data.mainProductService === "gas") {
        gasformData.value = data;
      } else if (data.mainProductService === "elec") {
        elecformData.value = data;
      }
    };
    const UpdateSuppliers = (suppliers) => {
      selectedSuppliers.value = suppliers;
    };
    const showRenewableOnly = ref(false);

const filteredQuotes = computed(() => {
  return showRenewableOnly.value
    ? elecSuppliersRateList.value.filter(q => q.IsRenewable)
    : elecSuppliersRateList.value;
});
    const updateSupplierList = (isCustom) => {
      if (!isCustom) {
        if (activeTab.value === "gas") {
          suppliersRateList.value = [...gasPriceList.value].filter(item => item.isCustom !== true)
          // suppliersRateList.value = [...suppliersRateList.value].filter(item => item.isCustom !== true)
        } else {
          elecSuppliersRateList.value = [...elecPriceList.value].filter(item => item.isCustom !== true)
        }
      } else {
        if (activeTab.value === "gas") {
          suppliersRateList.value = [...gasPriceList.value]
          // suppliersRateList.value = [...suppliersRateList.value]
        } else {
          elecSuppliersRateList.value = [...elecPriceList.value]
        }
      }
    }

    const compare = async () => {
      let payload;

      if (activeTab.value === "gas") {
        const custom_uplift_data = editableUplift.value.reduce((acc, item) => {
          if (item && item.id && item.Uplift !== undefined) {
            acc[item.id] = item.Uplift;
          }
          return acc;
        }, {});
        formData.value = gasformData.value;
        const prevUplift = formData.value.uplift_text;
        if (Object.keys(custom_uplift_data).length) {
          payload = {
            formData: {
              ...formData.value,
              uplift_text: 'custom',
              custom_uplift_data: custom_uplift_data,
              previous_uplift_text: prevUplift,
              quoteDetails: {
                ...formData.value.quoteDetails,
                GasSupply: {
                  ...formData.value.quoteDetails.GasSupply,
                  ContractRenewalDate: formateDate(formData.value.quoteDetails.GasSupply.ContractRenewalDate)
                }
              }
            }
          };
        } else {
          payload = {
            formData: {
              ...formData.value,
              custom_uplift_data: custom_uplift_data,
              previous_uplift_text: '',
              quoteDetails: {
                ...formData.value.quoteDetails,
                GasSupply: {
                  ...formData.value.quoteDetails.GasSupply,
                  ContractRenewalDate: formateDate(formData.value.quoteDetails.GasSupply.ContractRenewalDate)
                }
              }
            }
          };
        }
        if (formData.value.quoteDetails.PostCode === '' || formData.value.quoteDetails.GasSupply.Consumption.Amount === 0 || formData.value.quoteDetails.CurrentSupplier === '' || (formData.value.quoteDetails.GasSupply.ContractRenewalDate && (new Date(formData.value.quoteDetails.GasSupply.ContractRenewalDate) <= new Date())) || formData.value.quoteDetails.Settings[1].value === '0' || formData.value.quoteDetails.Uplift === null) {
          isNotValid.value = true;
          return;
        } else {
          isCompareGas.value = true
          isNotValid.value = false;
          const dateFormate = formData.value.quoteDetails.GasSupply.ContractRenewalDate;
          // const convertedDate = new Date(dateFormate).toISOString().split('T')[0];
          const convertedDate = new Date(dateFormate).toLocaleDateString("en-CA")
          localStorage.setItem('renewDate', convertedDate);
          localStorage.setItem('annual_usage', formData.value.quoteDetails.GasSupply.Consumption.Amount);
          const response = await store.dispatch(
            "price/getSupplierPrice",
            payload.formData
          );

          const list = customQuoteList.value.map((item) => {
            const annualPrice = calculateCurrentCost(item)
            return { ...item, 'AnnualPrice': annualPrice }
          })

          // suppliersRateList.value = [...suppliersRateList.value, ...list]
          if (response) {
            suppliersRateList.value = [...list, ...response];
            // editableUplift.value = []
          }
          // uniqueSuppliers.value = [
          //   ...new Set(suppliersRateList.value?.map((supplier) => supplier.Supplier)),
          // ];
          // customQuoteList.value = []

          const result = [];

          suppliersRateList.value.forEach(quote => {
            const existingSupplier = result.find(item => item.Supplier === quote.Supplier);

            const hasAnnualPrice = quote.AnnualPrice && quote.AnnualPrice !== "0";

            if (existingSupplier) {
              existingSupplier.IsRenewable =
                existingSupplier.IsRenewable || quote.IsRenewable;

              if (!existingSupplier.PlanType.includes(quote.PlanType || 'Default')) {
                existingSupplier.PlanType.push(quote.PlanType || 'Default');
              }

              if (hasAnnualPrice && !existingSupplier.Term.includes(quote.Term)) {
                existingSupplier.Term.push(quote.Term);
                existingSupplier.Term.sort((a, b) => a - b);
              }
            } else {
              result.push({
                Supplier: quote.Supplier,
                PlanType: [quote.PlanType || 'Default'],
                Term: hasAnnualPrice ? [quote.Term] : [],
                IsRenewable: quote.IsRenewable || false
              });
            }
          });
          if (!deepEqual(uniqueSuppliers.value, result)) {
            uniqueSuppliers.value = result
          }
          gasPriceList.value = [...suppliersRateList.value]
        }
      } else if (activeTab.value === "electricity") {
        // Sync latest form data from child before validating
        quotingElectricityRef.value?.emitFormData?.();
        await nextTick();
        const custom_uplift_data = editableElecUplift.value.reduce((acc, item) => {
          if (item && item.id && item.Uplift !== undefined) {
            acc[item.id] = item.Uplift;
          }
          return acc;
        }, {});
        formData.value = elecformData.value;
        const prevUplift = formData.value.uplift_text;
        if (Object.keys(custom_uplift_data).length) {
          // payload = {
          //   formData: {
          //     ...formData.value,
          //     uplift_text: 'custom',
          //     custom_uplift_data: custom_uplift_data,
          //     previous_uplift_text: prevUplift
          //   }
          // };
          payload = {
            formData: {
              ...formData.value,
              uplift_text: 'custom',
              custom_uplift_data: custom_uplift_data,
              previous_uplift_text: prevUplift,
              quoteDetails: {
                ...formData.value.quoteDetails,
                ElectricSupply: {
                  ...formData.value.quoteDetails.ElectricSupply,
                  ContractRenewalDate: formateDate(formData.value.quoteDetails.ElectricSupply.ContractRenewalDate)
                }
              }
            }
          };
        } else {
          // payload = {
          //   formData: {
          //     ...formData.value,
          //     custom_uplift_data: custom_uplift_data,
          //     previous_uplift_text: ''
          //   }
          // };
          payload = {
            formData: {
              ...formData.value,
              custom_uplift_data: custom_uplift_data,
              previous_uplift_text: '',
              quoteDetails: {
                ...formData.value.quoteDetails,
                ElectricSupply: {
                  ...formData.value.quoteDetails.ElectricSupply,
                  ContractRenewalDate: formateDate(formData.value.quoteDetails.ElectricSupply.ContractRenewalDate)
                }
              }
            }
          };
        }
        if (formData.value.quoteDetails.PostCode === '' || formData.value.quoteDetails.ElectricSupply.MPANTop === '' ||
          formData.value.quoteDetails.ElectricSupply.MPANBottom === '' || !Number(formData.value.quoteDetails.ElectricSupply.DayConsumption.Amount) || (formData.value.quoteDetails.ElectricSupply.ContractRenewalDate && (new Date(formData.value.quoteDetails.ElectricSupply.ContractRenewalDate) <= new Date())) || formData.value.quoteDetails.CurrentSupplier === '' || formData.value.quoteDetails.Settings[1].value === '0' || formData.value.quoteDetails.Uplift === null) {
          isElecNotValid.value = true;
          return;
        } else {
          isCompareElec.value = true
          const elecdateFormate = formData.value.quoteDetails.ElectricSupply.ContractRenewalDate;
          // const convertedElecDate = new Date(elecdateFormate).toISOString().split('T')[0];
          const convertedElecDate = new Date(elecdateFormate).toLocaleDateString("en-CA")
          localStorage.setItem('elec_renewDate', convertedElecDate);
          localStorage.setItem('elec_annual_usage', formData.value.quoteDetails.ElectricSupply.DayConsumption.Amount);
          isElecNotValid.value = false;
          if (formData.value.quoteDetails.ElectricSupply.NightConsumption.Amount === '') {
            formData.value.quoteDetails.ElectricSupply.NightConsumption.Amount = 0
          }
          if (formData.value.quoteDetails.ElectricSupply.WendConsumption.Amount === '') {
            formData.value.quoteDetails.ElectricSupply.WendConsumption.Amount = 0
          }
          if (formData.value.quoteDetails.ElectricSupply.KvaConsumption.Amount === '') {
            formData.value.quoteDetails.ElectricSupply.KvaConsumption.Amount = 0
          }
          const response = await store.dispatch(
            "price/getSupplierPrice",
            payload.formData
          );
          const list = elecCustomQuoteList.value.map((item) => {
            const annualPrice = calculateCurrentCostForElec(item)
            return { ...item, 'AnnualPrice': annualPrice, CapacityCharge: item.CapacityCharge ?? item.kva }
          })

          // elecSuppliersRateList.value = [...elecSuppliersRateList.value, ...list]
          if (response) {
            elecSuppliersRateList.value = [...list, ...response];
            // editableUplift.value = []
          }
          // uniqueElectricSuppliers.value = [
          //   ...new Set(elecSuppliersRateList.value?.map((supplier) => supplier.Supplier)),
          // ];

          // elecCustomQuoteList.value = []

          const result = [];

          elecSuppliersRateList.value.forEach(quote => {
            const existingSupplier = result.find(item => item.Supplier === quote.Supplier);

            const hasAnnualPrice = quote.AnnualPrice && quote.AnnualPrice !== "0";

            if (existingSupplier) {
              existingSupplier.IsRenewable =
                existingSupplier.IsRenewable || quote.IsRenewable;

              if (!existingSupplier.PlanType.includes(quote.PlanType || 'Default')) {
                existingSupplier.PlanType.push(quote.PlanType || 'Default');
              }

              if (hasAnnualPrice && !existingSupplier.Term.includes(quote.Term)) {
                existingSupplier.Term.push(quote.Term);
                existingSupplier.Term.sort((a, b) => a - b);
              }
            } else {
              result.push({
                Supplier: quote.Supplier,
                PlanType: [quote.PlanType || 'Default'],
                Term: hasAnnualPrice ? [quote.Term] : [],
                IsRenewable: quote.IsRenewable || false
              });
            }
          });
          // uniqueElectricSuppliers.value = result
          if (!deepEqual(uniqueElectricSuppliers.value, result)) {
            uniqueElectricSuppliers.value = result;
          }

          elecPriceList.value = [...elecSuppliersRateList.value]

        }
      }

      if (formData.value.mainProductService === "elec") {
        isElectric.value = true;
      } else {
        isElectric.value = false;
      }
    };
    function deepEqual(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    }
    const filteredSuppliers = computed(() => {
      const suppliers =
        activeTab.value === "gas"
          ? uniqueSuppliers.value
          : uniqueElectricSuppliers.value;

      if (!showRenewableOnly.value) {
        return suppliers;
      }

      return suppliers.filter(supplier => supplier.IsRenewable);
    });

    const filteredSuppliersRateList = computed(() => {
       const suppliers = activeTab.value === "gas" ? suppliersRateList.value : elecSuppliersRateList.value;
       if (!showRenewableOnly.value) {
        return suppliers;
      }
      return suppliers.filter(supplier => supplier.IsRenewable);
    });

    const onInput = () => {
      searchSupplier();
    };

    const searchSupplier = () => {
      const query = form.value?.Supplier?.toLowerCase();
      if (query) {
        filteredSupp.value = supplierOptions.value.filter((org) => {
          const nameMatch = org.name.toLowerCase().includes(query);
          return nameMatch;
        });
      } else {
        // If the query is empty, hide the dropdown
        filteredSupp.value = [];
      }
    };

    const showDropdown = () => {
      // Show all suppliers when the input is focused (clicked)
      if (!form.value.Supplier) {
        filteredSupp.value = supplierOptions.value;
      }
    };

    const selectSupplier = (supplier) => {
      form.value.Supplier = supplier.name;

      filteredSupp.value = [];
    };

    const hideDropdown = () => {
      filteredSupp.value = [];
    };

    const handleClickOutside = (event) => {
      // Check if the click happened outside the dropdown container
      if (
        dropdownContainer.value &&
        !dropdownContainer.value.contains(event.target)
      ) {
        hideDropdown();
      }
    };

    const addCustomQuote = () => {
      const modal = new Modal(document.getElementById("custom_quote"));
      modal.show();
    }

    const cancel_change = () => {
      Object.keys(form.value).forEach(key => {
        if (key === 'isCustom') {
          form.value[key] = true;
        } else if (key === 'Supplier') {
          form.value[key] = '';
        } else {
          form.value[key] = '';
        }
      });
      isValid.value = {
        supplier: false,
        term: false
      };

      isUplift.value = false
      document.getElementById("close-btn").click()
    }

    const handleUplift = () => {
      if (isUplift.value) {
        form.value.Uplift = ''
      }
    }

    const confirm_change = () => {
      if (form.value.Supplier === '') {
        isValid.value.supplier = true;
        return
      }

      isValid.value.supplier = false

      if (!form.value.Term) {
        isValid.value.term = true;
        termError.value = 'Term is required'
        return
      } else if (isNaN(form.value.Term)) {
        isValid.value.term = true;
        termError.value = 'Please enter a valid number'
        return
      } else if (form.value.Term < 1) {
        isValid.value.term = true;
        termError.value = 'Term should be at least 1'
        return
      } else if (form.value.Term > 5) {
        isValid.value.term = true;
        termError.value = 'Term should not be more than 5'
        return
      }

      termError.value = ''
      isValid.value.term = false

      if (form.value.PlanType === '' || form.value.PlanType === null) {
        form.value.PlanType = 'Default'
      }

      form.value.Term = Math.ceil(form.value.Term * 12) + ''

      if (activeTab.value === 'gas') {
        if (suppliersRateList.value.length === 0 && isCompareGas.value === false) {
          customQuoteList.value.push({ ...form.value })
        } else {
          customQuoteList.value.push({ ...form.value })
          const annual_price = calculateCurrentCost(form.value)

          if (gasPriceList.value.length > 0) {
            suppliersRateList.value = [...gasPriceList.value]
          }
          suppliersRateList.value.unshift({ ...form.value, 'AnnualPrice': annual_price });
          // uniqueSuppliers.value.push(form.value.Supplier)

          const result = [];

          suppliersRateList.value.forEach(quote => {
            const existingSupplier = result.find(item => item.Supplier === quote.Supplier);

            const hasAnnualPrice = quote.AnnualPrice && quote.AnnualPrice !== "0";

            if (existingSupplier) {
              existingSupplier.IsRenewable =
                existingSupplier.IsRenewable || quote.IsRenewable;

              if (!existingSupplier.PlanType.includes(quote.PlanType || 'Default')) {
                existingSupplier.PlanType.push(quote.PlanType || 'Default');
              }

              if (hasAnnualPrice && !existingSupplier.Term.includes(quote.Term)) {
                existingSupplier.Term.push(quote.Term);
                existingSupplier.Term.sort((a, b) => a - b);
              }
            } else {
              result.push({
                Supplier: quote.Supplier,
                PlanType: [quote.PlanType || 'Default'],
                Term: hasAnnualPrice ? [quote.Term] : [],
                IsRenewable: quote.IsRenewable || false
              });
            }
          });
          uniqueSuppliers.value = result

          gasPriceList.value = [...suppliersRateList.value]
        }
      } else {

        if (kvaselection.value === 'permonth') {
          form.value.kva = (form.value.kva / 31).toFixed(5)
        }

        if (elecSuppliersRateList.value.length === 0 && isCompareElec.value === false) {
          elecCustomQuoteList.value.push({ ...form.value, CapacityCharge: form.value.kva })
        } else {
          elecCustomQuoteList.value.push({ ...form.value, CapacityCharge: form.value.kva })
          const annual_price = calculateCurrentCostForElec(form.value)

          if (elecPriceList.value.length > 0) {
            elecSuppliersRateList.value = [...elecPriceList.value]
          }

          elecSuppliersRateList.value.unshift({ ...form.value, CapacityCharge: form.value.kva, 'AnnualPrice': annual_price });
          // uniqueElectricSuppliers.value.push(form.value.Supplier)
          const result = [];

          elecSuppliersRateList.value.forEach(quote => {
            const existingSupplier = result.find(item => item.Supplier === quote.Supplier);

            const hasAnnualPrice = quote.AnnualPrice && quote.AnnualPrice !== "0";

            if (existingSupplier) {
              existingSupplier.IsRenewable =
                existingSupplier.IsRenewable || quote.IsRenewable;

              if (!existingSupplier.PlanType.includes(quote.PlanType || 'Default')) {
                existingSupplier.PlanType.push(quote.PlanType || 'Default');
              }

              if (hasAnnualPrice && !existingSupplier.Term.includes(quote.Term)) {
                existingSupplier.Term.push(quote.Term);
                existingSupplier.Term.sort((a, b) => a - b);
              }
            } else {
              result.push({
                Supplier: quote.Supplier,
                PlanType: [quote.PlanType || 'Default'],
                Term: hasAnnualPrice ? [quote.Term] : [],
                IsRenewable: quote.IsRenewable || false
              });
            }
          });
          uniqueElectricSuppliers.value = result

          elecPriceList.value = [...elecSuppliersRateList.value]
        }
      }

      cancel_change()
    }

    const parseSafeNumber = (value) => {
      if (value === null || value === undefined) {
        return 0;
      }
      const numericValue =
        typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;
      const parsed = parseFloat(numericValue);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const calculateCurrentCost = (item) => {
      // old rate annual price calculation
      const annualPrice = parseFloat(formData.value?.quoteDetails?.GasSupply?.Consumption.Amount) || 0;
      const oldRate = parseFloat(item.DayUnitrate) || 0;
      const uplift = parseFloat(item.Uplift) || 0;
      const totalRate = oldRate + uplift
      const annual_rate = (annualPrice * totalRate) / 100;
      const additional_charge = parseFloat(item.AdditionalCharge) || 0;
      // old rate annual price calculation
      const standingCharge = parseFloat(item.StandingCharge) || 0;
      const statngCalc = (standingCharge * 365) / 100;

      // calculate current rate
      return `£${(annual_rate + statngCalc + additional_charge).toFixed(2)}`;
    };

    const calculateCurrentCostForElec = (item) => {
      // Helper function to safely parse and handle NaN
      const parseAmount = (value) => parseFloat(value) || 0;

      // Extracting form data values for easier access
      const electricSupply = formData.value?.quoteDetails?.ElectricSupply;
      const feedTariff = parseAmount(formData.value.quoteDetails.FeedTariff);
      const standingCharge = parseAmount(item.StandingCharge);
      const additional_charge = parseFloat(item.AdditionalCharge) || 0;

      // Old rate annual price calculations
      const annualPrice = parseAmount(electricSupply?.DayConsumption.Amount);
      // const oldDayPrice = parseAmount(electricSupply?.OldDayConsumption.Amount);
      const oldDayPrice = parseAmount(item.DayUnitrate);
      const annual_rate = (annualPrice * oldDayPrice) / 100;

      const annualNightPrice = parseAmount(electricSupply.NightConsumption.Amount);
      // const oldNightPrice = parseAmount(electricSupply.OldNightConsumption.Amount);
      // const annualNightPrice = parseAmount(item.NightUnitrate);
      // const oldNightPrice = parseAmount(item.DayUnitrate);
      const oldNightPrice = parseAmount(item.NightUnitrate);
      // const uplift = parseFloat(item.Uplift) || 0;
      // const totalRate = oldRate + uplift
      const night_rate = (annualNightPrice * oldNightPrice) / 100;

      const annualWeekendPrice = parseAmount(electricSupply?.WendConsumption.Amount);
      const oldWeekendPrice = parseAmount(item.WendUnitrate);
      const weekend_rate = (annualWeekendPrice * oldWeekendPrice) / 100;

      const kvaConsumption = parseAmount(item.kva);
      const kvaDayConsumption = parseAmount(electricSupply?.KvadayConsumption);
      const kvaConsumption_rate = (kvaConsumption * kvaDayConsumption * 365) / 100;

      // Feed tariff calculations
      const feed_annual_rate = (annualPrice * feedTariff) / 100;
      const feed_value_rate = feed_annual_rate + (annualNightPrice * (oldNightPrice + feedTariff)) / 100;

      // Standing charge calculation
      const standingChargeCost = (standingCharge * 365) / 100;

      // Calculate total cost based on feed_value_rate
      let totalCost;
      if (feed_value_rate !== 0) {
        totalCost = annual_rate + weekend_rate + standingChargeCost + additional_charge + kvaConsumption_rate + feed_value_rate;
      } else {
        totalCost = annual_rate + night_rate + weekend_rate + standingChargeCost + additional_charge + kvaConsumption_rate + feed_value_rate;
      }

      // Update the current cost in formData
      return `£${totalCost.toFixed(2)}`;
    };

    const ensurePozitiveBaseUplift = (supplier) => {
      if (
        supplier?.Supplier === 'Pozitive Energy' &&
        supplier._basePozitiveUplift === undefined
      ) {
        supplier._basePozitiveUplift = parseSafeNumber(supplier.Uplift);
      }
    };

    const resolvePozitiveElecCap = (supplier) => {
      const ranges = pozitiveElecUpliftsRange.value || [];
      if (!ranges.length) {
        return supplier._basePozitiveUplift ?? parseSafeNumber(supplier.Uplift);
      }

      const dayEac = parseSafeNumber(
        supplier?.originalData?.dayEAC ??
        supplier?.originalData?.DayConsumption ??
        supplier?.DayConsumption
      );

      if (!dayEac) {
        return supplier._basePozitiveUplift ?? parseSafeNumber(supplier.Uplift);
      }

      const matchedRange = ranges.find((range) => {
        const rangeFrom = parseSafeNumber(range.from);
        const rangeTo = parseSafeNumber(range.to);
        return dayEac >= rangeFrom && dayEac <= rangeTo;
      });

      if (matchedRange && matchedRange.uplift !== undefined) {
        return parseSafeNumber(matchedRange.uplift);
      }

      return supplier._basePozitiveUplift ?? parseSafeNumber(supplier.Uplift);
    };

    const capPozitiveUplift = (uplift, supplier) => {
      if (supplier?.Supplier !== 'Pozitive Energy') {
        return uplift;
      }

      ensurePozitiveBaseUplift(supplier);

      if (activeTab.value === 'gas') {
        return Math.min(uplift, 1.5);
      }

      const baseLimit = resolvePozitiveElecCap(supplier);
      return Math.min(uplift, baseLimit || uplift);
    };

    const changedUpliftData = (supplier, uplift) => {
      const original = supplier?.originalData;
      if (!original) {
        return;
      }

      const customUplift = parseSafeNumber(uplift);
      const dayPrice = parseSafeNumber(original.DayPrice) > 0
    ? parseSafeNumber(original.DayPrice) + customUplift
    : 0.000;
      const nightPrice =  parseSafeNumber(original.NightPrice) > 0
    ? parseSafeNumber(original.NightPrice) + customUplift
    : 0.000;
      const weekendPrice = parseSafeNumber(original.EWEPrice) > 0
    ? parseSafeNumber(original.EWEPrice) + customUplift
    : 0.000;

      const dayEac = parseSafeNumber(original.dayEAC);
      const nightEac = parseSafeNumber(original.nightEAC);
      const weekendEac = parseSafeNumber(original.weekendEAC);
      const standingCharge = parseSafeNumber(original.StandingCharge);

      const dayCost = (dayPrice * dayEac) / 100;
      const nightCost = (nightPrice * nightEac) / 100;
      const weekendCost = (weekendPrice * weekendEac) / 100;
      const standingCost = (standingCharge * 365) / 100;

      supplier.DayUnitrate = Number(dayPrice.toFixed(3));
      supplier.NightUnitrate = Number(nightPrice.toFixed(3));
      supplier.WendUnitrate = Number(weekendPrice.toFixed(3));
      supplier.AnnualPrice = `£${(standingCost + dayCost + nightCost + weekendCost).toFixed(3)}`;
    };

    const deleteRow = (index) => {
      if (activeTab.value === 'electricity') {
        elecSuppliersRateList.value.splice(index, 1)
        elecCustomQuoteList.value.splice(index, 1)
        elecPriceList.value.splice(index, 1)
      } else {
        suppliersRateList.value.splice(index, 1)
        customQuoteList.value.splice(index, 1)
        gasPriceList.value.splice(index, 1)
      }
    }

    // const changeUplift = (event, index, id) => {
    //   const uplift = event.target.value;
    //   if(activeTab.value === 'gas'){
    //     editableUplift.value[index] = {
    //     id: id,
    //     Uplift: uplift
    //   }
    //   } else {
    //     editableElecUplift.value[index] = {
    //     id: id,
    //     Uplift: uplift
    //   }
    //   }
    // }

    // const changeUplift = (value, index, id) => {
    //   console.log("valuevalue",value)
    //   const uplift = value;

    //   const updatedEntry = {
    //     id,
    //     Uplift: uplift
    //   };

    //   console.log("updatedEntry",updatedEntry)
    //   if (activeTab.value === 'gas') {
    //     const updatedList = [...editableUplift.value];
    //     updatedList[index] = updatedEntry;
    //     editableUplift.value = updatedList; // ✅ trigger reactivity
    //   } else {
    //     const updatedList = [...editableElecUplift.value];
    //     updatedList[index] = updatedEntry;
    //     editableElecUplift.value = updatedList; // ✅ trigger reactivity
    //     console.log("updatedList",updatedList)
    //   }
    // };

    const changeUplift = (value, index, id) => {
      const numericUplift = parseSafeNumber(value);

      const supplierListRef =
        activeTab.value === 'gas'
          ? suppliersRateList.value
          : elecSuppliersRateList.value;

      const supplierIndex = supplierListRef.findIndex(
        (supplier) => supplier?.Id === id
      );

      if (supplierIndex === -1) {
        return;
      }

      const supplier = supplierListRef[supplierIndex];
      ensurePozitiveBaseUplift(supplier);
      const uplift = capPozitiveUplift(numericUplift, supplier);
      const updatedEntry = { id, Uplift: uplift };

     

      // Clone the array to maintain reactivity
      const targetList = activeTab.value === 'gas' ? editableUplift.value : editableElecUplift.value;
      const updatedList = [...targetList];

      // Find existing index by ID
      const existingIndex = updatedList.findIndex(item => item?.id === id);

      if (existingIndex !== -1) {
        // If ID exists, update its value
        updatedList[existingIndex] = updatedEntry;
      } else {
        // Otherwise, add as new entry
        updatedList.push(updatedEntry);
      }

      // Assign back to reactive variable
      if (activeTab.value === 'gas') {
        editableUplift.value = updatedList;
      } else {
        editableElecUplift.value = updatedList;
      }

      supplier.Uplift = uplift;

      if (supplier?.Supplier === 'Pozitive Energy') {
        changedUpliftData(supplier, uplift);
        if (activeTab.value === 'gas') {
          suppliersRateList.value = [...supplierListRef];
          gasPriceList.value = [...supplierListRef];
        } else {
          elecSuppliersRateList.value = [...supplierListRef];
          elecPriceList.value = [...supplierListRef];
        }
      }
    };


    const formateDate = (dateString) => {
      let date
      if (dateString) {
        date = new Date(dateString);
        if (isNaN(date.getTime())) {
          return null;
        }
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        const formattedDate = `${yyyy}-${mm}-${dd}`;
        return formattedDate;
      }
    };
    const updateRenewableFilter = (value) => {
      showRenewableOnly.value = value;
    };
    // const updateRenewableFilter = (isRenewable) => {
    //   if (activeTab.value === 'gas') {
    //     suppliersRateList.value = gasPriceList.value.filter(supplier => supplier.IsRenewable === isRenewable);
    //   } else {
    //     elecSuppliersRateList.value = elecPriceList.value.filter(supplier => supplier.IsRenewable === isRenewable);
    //   }
    // };
    onMounted(async () => {
      document.addEventListener("click", handleClickOutside);
      // const queryFor = route.query.for?.toLowerCase()
      // if (queryFor === 'gas') {
      //   gasOppId.value = route.query.opp_Id;
      //   activeTab.value = 'gas';
      // } else {
      //   elecOppId.value = route.query.opp_Id;
      //   activeTab.value = 'electricity';
      // }
      if (route.query.for) {
        queryFor.value = route.query.for
        if (route.query.for === 'gas') {
          gasOppId.value = route.query.opp_Id
          activeTab.value = 'gas';
        } else {
          elecOppId.value = route.query.opp_Id
          activeTab.value = 'electricity';
        }
      }
    });

    return {
      // updateRenewableFilter,
      updateRenewableFilter,
      showRenewableOnly,
      filteredQuotes,
      gasOppId,
      territory_id,
      org_Id,
      opp_Id,
      emailValidation,
      elecOppId,
      isNotValid,
      validEmail,
      isElecNotValid,
      handleMinMonths,
      handleMaxMonths,
      minMonths,
      maxMonths,
      updateIsYear,
      selectedYears,
      updateSelectedYears,
      isYear,
      activeTab,
      gasformData,
      elecformData,
      isElectric,
      formData,
      compare,
      isFilterOpen,
      handleFilterToggle,
      submitFormData,
      suppliersRateList,
      elecSuppliersRateList,
      uniqueSuppliers,
      UpdateSuppliers,
      selectedSuppliers,
      uniqueElectricSuppliers,
      filteredSuppliers,
      filteredSuppliersRateList,
      form,
      addCustomQuote,
      cancel_change,
      confirm_change,
      calculateCurrentCost,
      customQuoteList,
      calculateCurrentCostForElec,
      pozitiveElecUpliftsRange,
      elecCustomQuoteList,
      deleteRow,
      searchSupplier,
      onInput,
      showDropdown,
      selectSupplier,
      hideDropdown,
      handleClickOutside,
      filteredSupp,
      dropdownContainer,
      supplierOptions,
      schema,
      isUplift,
      handleUplift,
      isValid,
      updateSupplierList,
      elecPriceList,
      gasPriceList,
      kvaselection,
      isCompareGas,
      isCompareElec,
      queryFor,
      termError,
      editableUplift,
      editableElecUplift,
      changeUplift,
      isEmailValid,
      isEmailValidElec,
      setActiveTab
    };
  },
};
</script>

<style scoped>
.contact-breadcrumb {
  li {
    a {
      font-size: 16px;
      /* color: #4983cf;
      &:hover{
        text-decoration: underline;
      } */
    }
  }
}

.filter-panel {
  position: fixed;
  right: -400px;
  top: 57px;
  width: 290px;
  background-color: #fff;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  z-index: 9999;
  height: 100%;
}

.filter-panel.open {
  right: 0;
}

.filter_btn {
  position: absolute;
  left: -20px;
}
</style>
